import { FC } from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck';
import { cn, FaIcon } from '@fe-learner-common';

type AriaProps = {
  [key: `aria-${string}`]: string | boolean | number;
};

export interface CheckboxProps extends AriaProps {
  className?: string;
  onChange: () => void;
  checked: boolean;
  disabled?: boolean;
  id: string;
  size: 'sm' | 'md' | 'lg';
}

export const checkboxSizeMap = {
  sm: 'lf:h-4 lf:w-4',
  md: 'lf:h-5 lf:w-5',
  lg: 'lf:h-6 lf:w-6',
};

export const Checkbox: FC<CheckboxProps> = ({
  checked,
  id,
  onChange,
  size,
  disabled,
  className,
  ...ariaProps
}) => (
  <CheckboxPrimitive.Root
    className={cn(
      'lf:flex lf:appearance-none lf:items-center lf:justify-center lf:rounded-sm lf:border lf:border-neutral-300 lf:bg-neutral-0 lf:hover:border-neutral-400 lf:data-[disabled]:border-neutral-200 lf:data-[state=checked]:border-prominence-500 lf:data-[disabled]:bg-neutral-50 lf:data-[state=checked]:bg-prominence-500 lf:hover:data-[state=checked]:border-prominence-500',
      checkboxSizeMap[size],
      className,
    )}
    onKeyDown={(e) => {
      if (e.key === 'Enter' && !disabled) {
        onChange();
      }
    }}
    checked={checked}
    onClick={(e) => {
      e.stopPropagation();
    }}
    onCheckedChange={onChange}
    id={id}
    disabled={disabled}
    {...ariaProps}
  >
    <CheckboxPrimitive.Indicator className="lf:flex lf:items-center lf:justify-center">
      <FaIcon
        width={12}
        height={12}
        className="lf:text-neutral-0"
        icon={faCheck}
      />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
);
